import { createApp } from "vue";
import { createPinia } from "pinia";

// import { useFilterStore } from "./stores/dynamic_stores/filterStore";
// import { useDialogeStore } from "./stores/dynamic_stores/dialogeStore";
// import { useTabStore } from "./stores/dynamic_stores/tabsStore";

import 'quill/dist/quill.snow.css';
import "./style.css";
import "primeicons/primeicons.css";
import App from "./App.vue";
import router from './router'
import Aura from './presets/aura';

//statemanagement package


// Primevue components import 
import PrimeVue from "primevue/config";
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';

// Directives
import StyleClass from "primevue/styleclass";
import Ripple from "primevue/ripple";

// Components
import Menubar from "primevue/menubar";
import Sidebar from 'primevue/sidebar';
import Button from "primevue/button";
import Avatar from "primevue/avatar";
import OverlayPanel from 'primevue/overlaypanel';
import PanelMenu from "primevue/panelmenu";
import Card from "primevue/card";
// import Checkbox from 'primevue/checkbox';
import InputText from "primevue/inputtext";
import Password from "primevue/password";
import TabMenu from "primevue/tabmenu";
import ProgressSpinner from "primevue/progressspinner";
import Column from "primevue/column";
import DataTable from "primevue/datatable";

import Chart from 'primevue/chart';
import Timeline from "primevue/timeline";

import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import Slider from "primevue/slider";
import TriStateCheckbox from "primevue/tristatecheckbox";
import MultiSelect from "primevue/multiselect";
import ProgressBar from "primevue/progressbar";
import Calendar from "primevue/calendar";
import Tag from "primevue/tag";
import InputNumber from "primevue/inputnumber";
import Dropdown from "primevue/dropdown";
import Dialog from "primevue/dialog";
import Checkbox from "primevue/checkbox";

import Tooltip from 'primevue/tooltip';
import FileUpload from "primevue/fileupload";
import ConfirmPopup from "primevue/confirmpopup";
import ConfirmationService from 'primevue/confirmationservice';

// intialize the http interceptors
import './http_interceptors';
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import SelectButton from "primevue/selectbutton";
import Toolbar from "primevue/toolbar";
import Textarea from "primevue/textarea";
import Tree from "primevue/tree";
import RadioButton from "primevue/radiobutton";
import Fieldset from "primevue/fieldset";
import Image from "primevue/image";
import Editor from "primevue/editor";
import hljs from 'highlight.js';
import 'highlight.js/styles/github.css'; // or any theme you like
import AvatarGroup from "primevue/avatargroup";
import Chip from "primevue/chip";
import Breadcrumb from "primevue/breadcrumb";


window.hljs = hljs; // expose globally for Quill to detect


const app = createApp(App);
app.use(createPinia())
app.use(router)
app.use(ToastService);
app.use(ConfirmationService);


//bind the directives and components to the vue app
app.directive("styleclass", StyleClass);
app.directive("ripple", Ripple);
app.directive('tooltip', Tooltip);

app.component("Menubar", Menubar);
app.component("Sidebar", Sidebar);
app.component("Button", Button);
app.component("Avatar", Avatar);
app.component("OverlayPanel", OverlayPanel);
app.component("PanelMenu", PanelMenu);
app.component("Card", Card);
// app.component("Checkbox", Checkbox);
app.component("InputText", InputText);
app.component("Password", Password);
app.component("TabMenu", TabMenu);
app.component("ProgressSpinner", ProgressSpinner);
app.component("Column", Column);
app.component("DataTable", DataTable);
app.component("Chart", Chart);
app.component("Timeline", Timeline);
app.component("InputIcon", InputIcon);
app.component("IconField", IconField);
app.component("TriStateCheckbox", TriStateCheckbox);
app.component("Slider", Slider);
app.component("ProgressBar", ProgressBar);
app.component("MultiSelect", MultiSelect);
app.component("Calendar", Calendar);
app.component("Tag", Tag);
app.component("InputNumber", InputNumber);
app.component("Dropdown", Dropdown);
app.component("Dialog", Dialog);
app.component("Checkbox", Checkbox);
app.component("Toast", Toast);
app.component("FileUpload", FileUpload);
app.component("ConfirmPopup", ConfirmPopup)
app.component("TabView", TabView)
app.component("TabPanel", TabPanel)
app.component("SelectButton", SelectButton)
app.component("Toolbar", Toolbar)
app.component("Textarea", Textarea)
app.component("Tree", Tree)
app.component("RadioButton", RadioButton)
app.component("Fieldset", Fieldset)
app.component("Image", Image)
app.component("Editor", Editor)
app.component("AvatarGroup", AvatarGroup)
app.component("Chip", Chip)
app.component("Breadcrumb", Breadcrumb)
// app.component("ProgressSpinner", ProgressSpinner);


app.use(
    PrimeVue,
    {
        unstyled: true,
        pt: Aura,
        ripple: true,
    }
);




// setting up the config for the production
if (process.env.NODE_ENV === 'production') {
    app.config.devtools = false;
    console.log = () => { };
    console.warn = () => { };
    console.error = () => { };
    document.addEventListener('contextmenu', event => {
        event.preventDefault();
    });
}


app.mount("#app");
